import { render } from "./EventWrapper.vue?vue&type=template&id=62d239a4"
import script from "./EventWrapper.vue?vue&type=script&lang=js"
export * from "./EventWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__